import api from './api.js'

// token请求
const client = process.env.AUTH_CLIENT
export function token(params){
    return api.post('/service-auth/oauth/token', {}, {params: client});
}
// 账号密码登录
export function getUserAndPassLogin(params){
    return api.post('/service-auth/oauth/login',params);
}
// 获取当前用户登录信息
export function getNewcurrent(params){
    return api.get('/service-center/api/v1/user/current',params);
}
// 文件上传
export function uploadFile(params){
    return api.post('/service-center/upload/file/single',params);
}
// 企业详情
export function getPrintEnterPriseInfo(){
    return api.get('/resource-print/api/v1/print/enterPrise/getPrintEnterPriseInfo');
}
// 评审中心动态获取菜单
export function getMenuList(){
    return api.get('/service-center/api/v1/security/service/resource/self/reviewCenterService');
}

// 领导审核动态获取菜单
export function getLeaderMenuList(){
    return api.get('/service-center/api/v1/security/service/resource/self/leaderExamineService');
}

// 获取融云token
export function getRongCloudToken(params){
    return api.get('/service-center/api/v1/rongcloud/getToken',params);
}

//（融云用）根据目标id获取用户或者企业管理员
export function getRongCloudUser(uuid){
    return api.get('/service-center/api/v1/user/rongCloud/' + uuid);
}
// 服务商详情页
export function findProvidersInfo(){
    return api.get('/resource-print/api/v1/shopper/providers/findProvidersInfo');
}

// 打印数
export function findMaterialCount(){
    return api.get('/resource-print/api/v1/material/manager/nose/findCountByEnterpriseId');
}
// 服务数
export function findServiceabilityCount(){
    return api.get('/resource-print/api/v1/serviceability/nose/findCountByEnterpriseId');
}
// 服务数
export function findStoreFollowCount(){
    return api.get('/resource-print/api/v1/follow/info/storeFollowCount');
}
// 根据主键查询材料类型信息
export function get(params){
    return api.get('/resource-order/api/v1/material/type/get',params);
}
// 获取首页数据
export function getPrintAndShopOrderCount(){
    return api.get('/resource-order/api/v1/order/print/getPrintAndShopOrderCount');
}

export function getSellerOrderPosition(){
    return api.get('/resource-print/api/v1/material/manager/getSellerOrderPosition');
}

export function getVolumeCount(){
    return api.get('/resource-print/api/v1/volume/getVolumeCount');
}

export function getPayOrderInfo(){
    return api.get('/resource-order/api/v1/pay/order/info/getPayOrderInfo');
}

// 获取作品数据
export function getWorksReviewList(params){
    return api.get('/resource-activity/api/v1/activity/works/review/query',params);
}

// 作品打分
export function saveWorksScore(params){
    return api.post(`/resource-activity/api/v1/activity/works/review/${params.uuid}`,params);
}

// 查询作品详情信息
export function getWorksDetail(uuid){
    return api.get(`/resource-activity/api/v1/activity/works/${uuid}`);
}

// 获取审核作品所有数据
export function getWorksLeaderList(params){
    return api.get('/resource-activity/api/v1/activity/works/leader/query',params);
}

// 评分信息
export function getWorksScoreInfo(params){
    return api.get('resource-activity/api/v1/activity/works/review/getWorksScoreInfo',params);
}

// 作品打分
export function saveLeaderExamine(params){
    return api.post('/resource-activity/api/v1/activity/works/leader/audit',params);
}

// 领导信息
export function getExamineWorksList(params){
    return api.get('resource-activity/api/v1/activity/works/leader/getExamineWorksList',params);
}
// 测试
// 短信登录
export function getMessagesLogin(params){
    return api.post('/service-auth/sms/login',params);
}
// 点击获取短息
export function getSmscode(params){
    return api.get('/service-auth/api/v2/sms/code',params);
}
// 校验用户名是否存在
export function existsUserName(params){
    return api.get('/service-center/api/v1/security/account/exists',params);
}
// 获取安全校验码
export function getSecurityCode(params){
    return api.get('/service-auth/api/v2/validate/code',params);
}


// 生成二维码接口
export function generateQrCode(parmas){
    return api.get('/service-auth/api/v1/qr/code',parmas);
}
// 获取扫码结果接口
export function scanCodeInfo(parmas){
    return api.get('/service-auth/api/v1/qr/code/info',parmas);
}
// 微信授权登录
export function weChatLogin(parmas){
    return api.get('/service-auth/api/v1/social/wechat',parmas);
}
// 微信登录账号绑定接口
export function weChatBind(parmas){
    return api.post('/service-auth/api/v1/social/wechat/bind',parmas);
}




// WEBPACK FOOTER //
// ./src/utils/interface.js